import "webroot/static/src/common/js/polyfill_ie.js";
import { DialogsService } from "approot/global/providers/uikit.dialogs";
import { postTo } from "webroot/static/src/common/js/common.navigation";
import { AccountInfo, StoredRefreshToken } from "../sessionstore";
import { LoginData, LoginDataService } from "./login.data.service";
import { DefaultEntryPage, LoginOptions, LoginService } from "./login.service";
import { IdentityProvider } from "../login.repository";
import { EsiaPermissOptions } from "../sso-choose-role.component";
import { EsiaProviders } from "../sso.login.component";

export class LoginStrategiesService {
	private destPage: string;
	private loginOptions: LoginOptions;

	/*@ngInject*/
	constructor(
		public language: any,
		loginDataService: LoginDataService,
		private loginService: LoginService,
		private $dialogs: DialogsService
	) {
		let loginData: LoginData = loginDataService.loginData;

		this.destPage = loginData.destPage;
		this.loginOptions = loginData.loginOptions;
	}

	loginInActiveSession(accountInfo: AccountInfo) {
		let path = this.destPage || DefaultEntryPage;
		let data = {
			at: accountInfo.activeToken
		}

		// todo. authorize_code

		postTo({
			path,
			params: data,
			nocache: false,
			auth: false,
			method: this.isSpaApplicationPath(path) ? "GET" : "POST",
		});
	}

	private isSpaApplicationPath(path: string): boolean {
		return /^\/app\/(?:diary|teacher)(?:\/|$)/i.test(path);
	}

	loginWithRefreshToken(getToken: StoredRefreshToken, addOpts?: any) {
		let options = Object.assign({}, this.loginOptions, { saveAccount: true });
		return this.loginService.loginWithRefreshToken(getToken.refreshToken, options, addOpts);
	}

	loginWithLoginPassCheck(loginName: string, password: string, schoolId, emId, options: LoginOptions, addOpts?: Record<string, string | boolean | number | undefined>): Promise<void> {
		if (!loginName) {
			this.$dialogs.message(this.language.Generic.Messages.kFillLogin);
			return;
		}
		if (!password) {
			this.$dialogs.message(this.language.Generic.Messages.kFillPassword);
			return;
		}

		// todo: тут роль походу не учитывается
		const promise = this.loginService.login(loginName, password, schoolId, emId, options, addOpts);
		return promise;
	}

	loginWithEsia() {
		this.loginWithProvider(IdentityProvider.Esia);
	}

	loginWithEsa() {
		this.loginWithProvider(IdentityProvider.Esa);
	}

	loginWithEsiaProviderPermissOptions(provider: IdentityProvider, esiaPermissOptions: EsiaPermissOptions) {
		this.loginWithProvider(provider, esiaPermissOptions);
	}

	private loginWithProvider(provider: IdentityProvider, esiaPermissOptions?: EsiaPermissOptions) {
		const idp: string = IdentityProvider[provider].toLowerCase();
		const postToParams = {
			path: `/webapi/sso/${idp}/crosslogin`,
			params: this.getPreparedParams(provider, esiaPermissOptions),
			formParams: { method: "get" },
			nocache: false, auth: false
		};
		postTo(postToParams);
	}

	private getPreparedParams(provider: IdentityProvider, esiaPermissOptions?: EsiaPermissOptions) {
		let data: any = {};
		let searchParams = new URLSearchParams(window.location.search);
		let responseType = searchParams.get('response_type') || this.loginOptions.responseType;
		if (responseType) {
			data.response_type = responseType;
		}

		let redirectUri = searchParams.get('redirect_uri') || this.loginOptions.redirectUri;
		if (redirectUri) {
			data.redirect_uri = redirectUri;
		}

		let clientId = searchParams.get('client_id') || this.loginOptions.clientId;
		if (clientId) {
			data.client_id = clientId;
		}

		let scope = searchParams.get('scope') || this.loginOptions.scope;
		if (scope) {
			data.scope = scope;
		}

		let state = searchParams.get('state') || this.loginOptions.state;
		if (state) {
			data.state = state;
		}

		let codeChallenge = searchParams.get('code_challenge') || this.loginOptions.codeChallenge;
		if (codeChallenge) {
			data.code_challenge = codeChallenge;
		}

		let codeChallengeMethod = searchParams.get('code_challenge_method') || this.loginOptions.codeChallengeMethod;
		if (codeChallengeMethod) {
			data.code_challenge_method = codeChallengeMethod;
		}

		let acrValues = searchParams.get('acr_values') || this.loginOptions.acrValues;
		if (acrValues) {
			data.acr_values = acrValues;
		}

		let loginState = this.loginOptions.loginState;
		if (loginState) {
			data.loginState = loginState;
		}

		if (EsiaProviders.checkID(provider)) {
			if (esiaPermissOptions) {
				if (esiaPermissOptions.esiaPermissions) {
					data.esia_permissions = 1;
				}
				if (esiaPermissOptions.esiaRole != undefined) {
					data.esia_role = esiaPermissOptions.esiaRole;
				}
			}
		}

		return data;
	}
}
